import { createSlice } from "@reduxjs/toolkit";
import { fetchFavorites, toggleFavorite } from "../actions/favoriteAction";

const favoriteSlice = createSlice({
    name: "favorite",
    initialState: {
        items: [],
        pagination: null,
        status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
        toggleStatus: "idle",
    },
    reducers: {
        resetToggleStatus: (state) => {
            state.toggleStatus = "idle";
        },
        addFavoriteItem: (state, action) => {
            // تجنب إضافة المنتج مرتين
            if (!state.items.some(item => item.id === action.payload.id)) {
                state.items.unshift(action.payload);
            }
        },
        removeFavoriteItem: (state, action) => {
            state.items = state.items.filter(item => item.id !== action.payload);
        },
        clearFavorites: (state) => {
            state.items = [];
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Favorites
            .addCase(fetchFavorites.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchFavorites.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.items = action.payload.data || [];
                state.pagination = action.payload.pagination || null;
            })
            .addCase(fetchFavorites.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            // Toggle Favorite
            .addCase(toggleFavorite.pending, (state) => {
                state.toggleStatus = "loading";
            })
            .addCase(toggleFavorite.fulfilled, (state, action) => {
                state.toggleStatus = "succeeded";
                // يتم تحديث الأيتمز هنا بناءً على البيانات المرجعة من السيرفر
                if (action.payload && action.payload.data) {
                    // إذا رجع السيرفر المنتج، سنضيفه أو نزيله
                    const productId = action.payload.data.id || action.payload.product_id;
                    const isFavorited = action.payload.is_favorited || action.payload.data.is_favorited;
                    
                    if (isFavorited) {
                        // إضافة المنتج إلى المفضلة
                        if (!state.items.some(item => item.id === productId)) {
                            state.items.unshift(action.payload.data);
                        }
                    } else {
                        // إزالة المنتج من المفضلة
                        state.items = state.items.filter(item => item.id !== productId);
                    }
                }
            })
            .addCase(toggleFavorite.rejected, (state, action) => {
                state.toggleStatus = "failed";
                state.error = action.payload;
            });
    },
});

export const { resetToggleStatus, addFavoriteItem, removeFavoriteItem, clearFavorites } = favoriteSlice.actions;
export default favoriteSlice.reducer;
